const place_list_button = {
  confirm: 'This branch has',
  confirm1: 'equipment in total. Do you want to generate all qr codes for this branch?',
  title: 'GENERATE QRCODE',
  else: 'This branch does not have any equipment. Add the equipment in the sheets of this branch and then print the qr codes.'
};

export default place_list_button;
